import Symbol from "./Symbol";
import { INSPECTOR_GENERATORS } from "../../../constants/inspectorConstants";

class LightningContactChargingCenter extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("LightningContactChargingCenter", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
        };                
    }

    getInspector() {
        return INSPECTOR_GENERATORS;
    }
}

export default LightningContactChargingCenter;
